import React, { useState, useEffect } from "react";
import FilterDropdowns from "../../components/FilterDropdowns/FilterDropdowns";
import ExploreCareersTiles from "./ExploreCareersTiles";
import { filterCareersEventBuilder, sendEvent } from "../../utils/event-helpers";
import { ContentfulTileProps, fetchResourceTilesByTagFilters } from "../../utils/contentful-helpers";
import { useAppSelector } from "../../app/store";

export interface TaggedResourceTiles {
  data: ContentfulTileProps[];
  tagFilter: string;
}

const ExploreCareers = () => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<TaggedResourceTiles[]>([]);
  const [filteredResourceTiles, setFilteredResourceTiles] = useState<TaggedResourceTiles[]>([]);
  const { userId, sessionId } = useAppSelector((state) => state.session);

  useEffect(() => {
    const tagFilters = ["Career General Resources", "Career Additional Resources"];
    fetchResourceTilesByTagFilters(tagFilters).then((results) => {
      setTaggedResourceTiles(results);
      setFilteredResourceTiles(results);
    });
  }, []);

  const handleSubfieldChange = (subfields: any[]) => {
    if (subfields.length === 0) {
      setFilteredResourceTiles(taggedResourceTiles);
      return;
    }
    const filteredTaggedResourceTiles = taggedResourceTiles.map(tile => {
      return {
        ...tile,
        data: tile.data.filter(tile => tile.data.keyword?.some(keyword => subfields.includes(keyword)))
      }
    });
    setFilteredResourceTiles(filteredTaggedResourceTiles);
    const allFilteredTiles = filteredTaggedResourceTiles.map(tile => tile.data).flat();
    const allTileTitles = allFilteredTiles.map(tile => tile.title);
    const filterCareersEvent = filterCareersEventBuilder(userId, sessionId, allTileTitles, {
      subfieldFilters: subfields
    });
    sendEvent(filterCareersEvent);
  };

  return (
    <>
      <div className="explore-careers">
        <div className="resources-container">
          <div className="align-headers">
            <div>
              <p
                className="career-highlighted-paragraph"
                style={{ paddingBottom: "14px", marginTop: "17px" }}
              >
                Career Exploration Resources
                <span style={{ marginRight: "15.5rem" }}></span>
              </p>
            </div>
            <div className="dropdown-list">
              <FilterDropdowns
                showSubfield={true}
                onSubfieldsChange={handleSubfieldChange}
              />
            </div>
          </div>
        </div>
        <div className="gap"></div>
        {/* Toggle Section Links for Mobile */}
        <div className="section-links">
          <a href="#general-resources" className="link-item">
            General Resources
          </a>
          <a href="#additional-resources" className="link-item">
            Subfield-Based Resources
          </a>
        </div>
      </div>

      <div>
        {filteredResourceTiles.map(tile => (
          <ExploreCareersTiles
            key={tile.tagFilter}
            resourceTiles={tile.data}
          />
        ))}
      </div>
    </>
  );
};

export default ExploreCareers;
